import { render } from "./ProductAdd.vue?vue&type=template&id=3057bb62&scoped=true"
import script from "./ProductAdd.vue?vue&type=script&lang=js"
export * from "./ProductAdd.vue?vue&type=script&lang=js"

import "./ProductAdd.vue?vue&type=style&index=0&id=3057bb62&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3057bb62"]])

export default __exports__